export default "__VITE_ASSET__dpHUbjTg__"